import React from 'react'
import style from '../../../styles/mystyle.module.css'
import { useTranslation } from 'next-i18next'
import config from '../../../next.config.js'
import { constants } from '../../../constants'
import Image from 'next/image'
import Share from '../../../components/components/Share/Share'
import { useMedia } from "../../../utils/use-media";
function NumberPhone(props) {
    const { t } = useTranslation("common")
    const mobile = useMedia("(max-width: 580px)");
    const tablet = useMedia("(max-width: 991px)");
    const desktop = useMedia("(min-width: 992px)");
    const [showdetails, setshowdetails] = React.useState(props.ShowDetails)
    return (

        <div className={style.phoneSquarestyle}>
            <div className={style.Container}>
                <div className={style.allcard}>
                    {/* {showdetails ?
                        mobile ?
                            <div className={style.phoneSquaredietInMobile+ " " + style.paddingfood}>
                                <div className={style.IconAndNumberInMobile }>
                                <div className={style.iconPhone}>
                                    <Image className={style.iconPhone} src={`${config.basePath}/assest/phoneIcon.svg`} width={100} height={100} alt={"hakeem"} /></div>
                                <div><p className={style.fontNum}>{constants.MobileDite}</p></div>
                                </div>
                            </div>
                            : <div className={style.phoneSquarediet + " " + style.paddingfood}>
                                <div className={style.iconPhone}>
                                    <Image className={style.iconPhone} src={`${config.basePath}/assest/phoneIcon.svg`} width={100} height={100} alt={"hakeem"} /></div>
                                <div><p className={style.fontNum}>{constants.MobileDite}</p></div>
                 
                            </div>
                        :
                        mobile ?
                            <div className={style.phoneSquaredietInMobile}>
                                <div className={style.IconAndNumberInMobile}>
                                    <div className={style.iconPhone}><Image className={style.iconPhone} src={`${config.basePath}/assest/phoneIcon.svg`} width={100} height={100} alt={"hakeem"} /></div>
                                    <div><p className={style.fontNum}>{constants.MobileMed} </p></div>
                                </div>
                                <div >
                                    <Share title={props.entityDetails &&props.entityDetails[0].transEntityDetails.length>0&& props.entityDetails[0].transEntityDetails[0].officialName} />
                                </div>
                            </div>
                            : */}
                            <div className={style.phoneSquarediet}>
                                <div className={style.iconPhone}><Image className={style.iconPhone} src={`${config.basePath}/assest/phoneIcon.svg`} width={100} height={100} alt={"hakeem"} /></div>
                                <div><p className={style.fontNum}>{constants.MobileMed} </p></div>
                                <div >
                                    <Share title={props.entityDetails && props.entityDetails[0].transEntityDetails.length>0&&props.entityDetails[0].transEntityDetails[0].officialName} />
                                </div>
                            </div>
                    {/* } */}
                </div>
            </div>
        </div>

    )
}

export default NumberPhone
